import React, { useContext } from 'react'
import { useObserver } from 'mobx-react-lite'

import { AppStoreContext } from '../../../contexts'
import Notification from './Notification'

export default function CustomNotifications(props) {
  /**
  |--------------------------------------------------
  | Context
  |--------------------------------------------------
  */
  const appStore = useContext(AppStoreContext)

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return useObserver(() => {
    const { isOpenNotification, notiMessage, setIsOpenNotification, notiColor } = appStore

    return (
      <Notification
        color={notiColor}
        open={isOpenNotification}
        message={notiMessage}
        onClose={() => setIsOpenNotification(false)}
      />
    )
  })
}
